"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _immer = _interopRequireDefault(require("immer"));

var _lodash = require("lodash");

var _antd = require("antd");

var _EditorFields = require("../EditorFields");

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Group = function Group(props) {
  var id = props.id,
      label = props.label,
      instructions = props.instructions,
      site = props.site,
      fields = props.fields,
      value = props.value,
      onChange = props.onChange,
      dispatch = props.dispatch;
  var values = value || {};

  var handleChange = function handleChange(item) {
    var newValues = (0, _immer.default)(values, function (draft) {
      (0, _lodash.set)(draft, "".concat(item.id), item.value);
      return draft;
    });
    onChange(newValues);
  };

  return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    expandIconPosition: "right"
  }, /*#__PURE__*/_react.default.createElement(_antd.Collapse.Panel, {
    header: "".concat(label || id)
  }, instructions && /*#__PURE__*/_react.default.createElement(LabelContainer, null, /*#__PURE__*/_react.default.createElement(_antd.Typography.Text, {
    type: "secondary",
    children: instructions
  })), fields && fields.map(function (field, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, (0, _EditorFields.getField)({
      field: _objectSpread(_objectSpread({}, field), {}, {
        value: values === null || values === void 0 ? void 0 : values[field.id]
      }),
      index: index,
      site: site,
      onChangeElement: function onChangeElement(value) {
        return handleChange(value);
      },
      dispatch: dispatch
    }));
  })));
};

var LabelContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding: 12px 4px 0;\n"])));

var _default = Group;
exports.default = _default;